// utils/visitorInfo.js
import FingerprintJS from '@fingerprintjs/fingerprintjs';

export const getVisitorInfo = async () => {
  // Check if fingerprint is already stored locally
  let storedFingerprint = localStorage.getItem('_adminFingerprint_');

  if (!storedFingerprint) {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    storedFingerprint = result.visitorId;

    // Store permanently in localStorage
    localStorage.setItem('_adminFingerprint_', storedFingerprint);
  }

  // Get IP, location, and ISP info
  // const ipResponse = await fetch('https://ipapi.co/json/');
  // const ipData = await ipResponse.json();

  return {
    fingerprint: storedFingerprint, // Static per device/browser
    // ip: ipData.ip,
    // city: ipData.city,
    // region: ipData.region,
    // country: ipData.country_name,
    // isp: ipData.org, // ISP / Organization
    // latitude: ipData.latitude,
    // longitude: ipData.longitude,
    ip: "",
    city: "",
    region: "",
    country: "",
    isp: "", // ISP / Organization
    latitude: "",
    longitude: "",
  };
};
